import React from "react";
import Banner from "../containers/Saas/Banner";
import HeaderMenu from "../containers/Saas/HeaderMenu";
import Footer from "../containers/Saas/Footer";
import Features from "../containers/Saas/Features";
import KeyFeatures from "../containers/Saas/KeyFeatures";
import OurProduct from "../containers/Saas/OurProduct";
import Performance from '../containers/Saas/Performance';
import Pricing from '../containers/Saas/Pricing';
import Faq from '../containers/Saas/Faq';
import Testimonials from '../containers/Saas/Testimonials';
import GlobalStyle from "../containers/Saas/Common/global-styles";
import "../components/layout.css";
import SEO from "../components/seo"
import Fonts from "../containers/Saas/Common/fonts"
import Contact from "../containers/Saas/Contact";


const IndexPage = () => (
   <div>
       <Fonts />
        <GlobalStyle />
        <HeaderMenu/>

        <main>
            <SEO 
                title="DocKeeper chain of responsibility | document tracker"
                description="DocKeeper is a chain of responsibility app designed to put the onus on the supplier, employee or client"
            />
            <Banner/>
            <KeyFeatures/>
            <Features/>
            <OurProduct/>
            <Performance/>
            <Faq/>
            <Pricing/>
            <Contact />
            {/* <Testimonials/> */}
        </main>

        <Footer/>
   </div>

)

export default IndexPage;
